import { render, staticRenderFns } from "./ItemInbodyImgUploader.vue?vue&type=template&id=790801c4&scoped=true&lang=pug&"
import script from "./ItemInbodyImgUploader.vue?vue&type=script&lang=js&"
export * from "./ItemInbodyImgUploader.vue?vue&type=script&lang=js&"
import style0 from "./ItemInbodyImgUploader.vue?vue&type=style&index=0&id=790801c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790801c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
